import Button from "components/ui/Button/Button";
import ViewBulletins from "features/bulletins/components/ViewBulletins";
import { useEntity } from 'hooks/useEntity'
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";
import TopBanner from "layout/TopBanner/TopBanner";
import ImageHero from "features/bulletins/assets/images/hero-prikbord.png?v2";
import { ReactComponent as IconMegaphone } from "assets/images/icons/megaphone.svg";
import ViewContextProvider from "features/view/context/ViewContext";
import { useHistory } from "react-router-dom";
import { useLocationAwareSortOptions } from "hooks/useLocationAwareSortOptions";
import BulletinCreateButton from "features/bulletins/components/BulletinCreateButton";

function BulletinBoard({ title }) {
  const history = useHistory();
  const { entity, isLoading, error } = useEntity('/prikbord', 'page');
  const sortOptions = useLocationAwareSortOptions();

  useTitle(title);

  if (error) {
    return <Alert/>;
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value || '' }
                 intro={ entity?.field_intro?.value || '' }
                 image={ ImageHero }
                 sortOptions={ sortOptions }>

        { !isLoading && <BulletinCreateButton categoryId={ entity.field_bulletin_category.id }/> }

        <Button variant="secondary" onClick={ () => history.push('/prikbord/mijn-prikbord') }>
          <IconMegaphone/>
          Mijn prikbordberichten
        </Button>
      </TopBanner>
      <div className="wrapper--fluid grid">
        <div className="content content--background">
          <div className="grid">
            { !isLoading &&
              <ViewContextProvider name={ `bulletin/list/${ entity.field_bulletin_category.id }` }>
                <ViewBulletins/>
              </ViewContextProvider>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default BulletinBoard;
